module.exports = __webpack_public_path__ + "static/img/15.c549a6c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/5/zh/15.png
// module id = M6CX
// module chunks = 0